import { fixedUi } from '@/i18n/fixedUi';
import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { showToast } from '@/utils/toast';
import { parseBatchTokens, BATCH_QUERY_LIMIT } from './batchQueryUtils';

/**
 * 批量查询弹窗：换行或逗号分隔，上限 500 条
 */
export default function BatchQueryModal({
  open,
  title = fixedUi("批量查询"),
  initialValue = '',
  placeholder = '每行一条，或用逗号分隔；最多 500 条',
  onConfirm,
  onClose,
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) return;
    const tokens = parseBatchTokens(initialValue);
    setText(tokens.length ? tokens.join('\n') : '');
  }, [open, initialValue]);

  const tokens = useMemo(() => parseBatchTokens(text), [text]);
  const count = tokens.length;
  const overLimit = count > BATCH_QUERY_LIMIT;

  if (!open) return null;

  const handleConfirm = () => {
    const next = tokens.slice(0, BATCH_QUERY_LIMIT);
    if (overLimit) {
      showToast(`已按上限保留前 ${BATCH_QUERY_LIMIT} 条`, 'info');
    }
    onConfirm?.(next);
    onClose?.();
  };

  return createPortal(
    <div className="tpo-batch-modal tpo-batch-modal--no-backdrop-close" role="presentation">
      <div className="tpo-batch-modal__backdrop" aria-hidden="true" />
      <div
        className="tpo-batch-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tpo-batch-modal-title"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tpo-batch-modal__head">
          <h2 id="tpo-batch-modal-title">{title}</h2>
          <button type="button" className="tpo-btn tpo-btn--ghost tpo-btn--sm" onClick={onClose}>
            {fixedUi("关闭")}
          </button>
        </div>
        <div className="tpo-batch-modal__body">
          <div className="tpo-batch-modal__meta">
            <p className="tpo-batch-modal__hint">
              支持换行或逗号分隔，单次最多查询 {BATCH_QUERY_LIMIT} 条
            </p>
            <span className={`tpo-batch-modal__count${overLimit ? ' tpo-batch-modal__count--warn' : ''}`}>
              已输入 {count} / {BATCH_QUERY_LIMIT}
              {overLimit ? '（超出将截断）' : ''}
            </span>
          </div>
          <textarea
            className="tpo-textarea tpo-batch-modal__textarea"
            value={text}
            placeholder={placeholder}
            onChange={(e) => setText(e.target.value)}
            rows={14}
            autoFocus
          />
        </div>
        <div className="tpo-batch-modal__foot">
          <button type="button" className="tpo-btn tpo-btn--secondary tpo-btn--sm" onClick={onClose}>
            {fixedUi("取消")}
          </button>
          <button type="button" className="tpo-btn tpo-btn--primary tpo-btn--sm" onClick={handleConfirm}>
            确认
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
